var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',_vm._g(_vm._b({class:_vm.getClasses,attrs:{"cols":_vm.cols,"lg":_vm.lg,"md":_vm.md,"sm":_vm.sm}},'v-col',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }